<div class="editFormDefault__cont">
  <div class="editFormDefault--icon">
    <app-ds-icon
      [icon]="iconEdit"
      [size]="14">
    </app-ds-icon>
  </div>
  <app-ds-typography
    [size]="typographyFontSize.XXXS"
    [tag]="'p'"
    [color]="typographyColor.Secondary"
    [text]="'BOOKING_MODULE.BILLING.PROFILE_DELETE' | transloco">
  </app-ds-typography>
  <div class="editFormDefault--action">
    <app-ds-typography
      [size]="typographyFontSize.XXXS"
      [tag]="'p'"
      [color]="typographyColor.Highlight"
      [textDecoration]="'underline'"
      [text]="'BOOKING_MODULE.BILLING.DELETE' | transloco"
      (click)="clickDelete.emit()">
    </app-ds-typography>
  </div>
</div>